<template>
    <div class="news-item-innerwrap" v-if="categoryData.length > 0 " @click="GTMProdCatClick(name)">
        <div class="news-item">
            <router-link :to="{ name:'NewsDetails_' + currentLangName(), params: {news_slug: news_slug, news_category_slug: categoryData[0].slug}}">
                <div class="name">{{  name }}</div>  
                <div class="date">{{ date }}</div>
                <div class="short-desc">{{ short_description }}</div>            
            </router-link> 
        </div>      
    </div>
</template>

<script>


export default {
    data(){
        return {
            categoryId: [],
            src_url: process.env.VUE_APP_BIFROST_API_URL_NO_PROJECTNAME
        }
    },   
    props: ['name', 'date', 'id', 'news_slug', 'short_description', 'youtube_id', 'srcset', 'src'],
    computed:{                      
        categoryData(){             
            let categoryArray = this.$store.getters.getNewsCategory;                   
            return this.getCategoryData(this.id, categoryArray  )
        }            
    },
    methods:{
         GTMProdCatClick(article){          
            this.setDataLayer('article_details', article, '')                  
        }
    }   
}
</script>